import { render, staticRenderFns } from "./mergeCaseSuggestion.vue?vue&type=template&id=11594773"
import script from "./mergeCaseSuggestion.vue?vue&type=script&lang=js"
export * from "./mergeCaseSuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports